export const ERROR_CODE_NOT_AUTHORIZED = 401;
export const ERROR_CODE_NOT_VALIDATED = 422;

export const ERROR_MSG_CRITICAL = 'Wystąpił błąd, spróbuj ponownie';
export const ERROR_MSG_VALIDATION = 'Formularz zawiera błędy';
export const ERROR_MSG_NOT_AUTHOIZED = 'Brak dostępu';
export const ERROR_MSG_WRONG_CREDENTIALS = 'Błędny login lub hasło';

export const ERROR_NEWSLETTER_YOU_ARE_SAVE = 'Konto o podanym adresie e-mail już istnieje';
